const logger = {
  warn: (message) => {
    console.warn(`[Linear] \u26A0 WARN: ${message}}`);
  }
};

export { logger };
//# sourceMappingURL=logger.mjs.map
